module.exports = __webpack_public_path__ + "static/media/clases-3.539e139d.jpg";